import React, { useState } from "react";

const MessageWithTruncating = ({ str, maxLength }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      {showMore ? str : str.substr(0, maxLength - 1)}
      {showMore ? (
        <button
          onClick={() => setShowMore(false)}
          className="default-button-link"
        >
          ...less
        </button>
      ) : (
        <button
          onClick={() => setShowMore(true)}
          className="default-button-link"
        >
          more...
        </button>
      )}
    </>
  );
};

export default MessageWithTruncating;
